module.exports = __webpack_public_path__ + "img/add-of-day.55b9f7dc.svg";